import { AxiosResponse } from 'axios';

import { getProgramDetailsUrl, getVodDetailsUrl } from 'config/api';

import {
    DETAILS_DATA_TYPES,
    getChannelIdFilter,
    getEpgProgramsPeriodFilter,
} from 'store/details/utils/constants';
import {
    BTVProgrammesResponse,
    ResponseError,
    VodResponse,
} from 'store/railsBuilder/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

import { noSeasonName } from 'screens/Detail/components/Seasons/constants';
import { DETAILS_PARAMS_TO_REQUEST_PARAMS } from 'screens/Detail/types';

function requestSeasonEpisodesData(
    type: DETAILS_DATA_TYPES,
    seasonNumber: number | typeof noSeasonName,
    seriesId: string,
    channelId?: string | undefined,
    page?: number,
    limit?: number,
):
    | Promise<
          AxiosResponse<BTVProgrammesResponse | VodResponse | ResponseError>
      >
    | undefined {
    if (type === DETAILS_DATA_TYPES.VOD && seasonNumber !== noSeasonName) {
        return NagraInstance.get(
            getVodDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber]:
                        seasonNumber,
                }),
                sort: JSON.stringify([
                    [
                        DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialEpisodeNumber,
                        1,
                    ],
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialId, 1],
                ]),
                page,
                limit,
            }),
        );
    }

    if (type === DETAILS_DATA_TYPES.PROGRAM && seasonNumber !== noSeasonName) {
        return NagraInstance.get(
            getProgramDetailsUrl({
                filter: JSON.stringify({
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.seriesId]: seriesId,
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.editorialSeasonNumber]:
                        seasonNumber,
                    ...getChannelIdFilter(channelId),
                    ...getEpgProgramsPeriodFilter(),
                }),
                sort: JSON.stringify([
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.episodeNumber, 1],
                    [DETAILS_PARAMS_TO_REQUEST_PARAMS.id, 1],
                ]),
                page,
                limit,
            }),
        );
    }

    return undefined;
}

export default requestSeasonEpisodesData;
